let cn = {
    REPASSTIPS: "请重复输入相同的密码",
    PHONENULL: "手机号不能为空",
    PHONEFORMAT: "请输入正确的手机号",
    CODEFORMAT: "请输入正确的验证码",
    PASSFORMAT: "请输入6-20位数字或字符串密码",
    PHONETIPS: "请输入11位手机号",
    REPNEWPASSTIPS: "请再次输入密码",
    VERCODETIPS: "请输入图形验证码",
    PHONECODETIPS: "请输入手机验证码",
    IMGCODENULL: "图像验证码不能为空",
    IMGCODECORRECT: "请输入正确的图形验证码",
    CODENULL: "验证码不能为空",
    NEWPASSNULL: "新密码不能为空",
    REPASSFAIL: "两次输入的密码不一致",
    IMGSIZEOVER: "图片大小应在2M以内",
    CAN_NOT_BE_EMPTY: "不能为空"

};
let tw = {
    REPASSTIPS: "請重複輸入相同的密碼",
    PHONENULL: "手機號不能為空",
    PHONEFORMAT: "請輸入正確的手機號",
    CODEFORMAT: "請輸入正確的驗證碼",
    PASSFORMAT: "請輸入6-20位數字或字符串密碼",
    PHONETIPS: "請輸入11位手機號",
    REPNEWPASSTIPS: "請再次輸入密碼",
    VERCODETIPS: "請輸入圖形驗證碼",
    PHONECODETIPS: "請輸入手機驗證碼",
    IMGCODENULL: "圖像驗證碼不能為空",
    IMGCODECORRECT: "請輸入正確的圖形驗證碼",
    CODENULL: "驗證碼不能為空",
    NEWPASSNULL: "新密碼不能為空",
    REPASSFAIL: "兩次輸入的密碼不一致",
    IMGSIZEOVER: "圖片大小應在2M以內",
    CAN_NOT_BE_EMPTY: "不能為空"
};
let en = {
    REPASSTIPS: 'Please enter the same password repeatedly',
    PHONENULL: "The phone number field is required",
    PHONEFORMAT: "Please input the correct cell phone number",
    CODEFORMAT: "Please enter correct verify code",
    PASSFORMAT: 'Please enter a 6-20 digit or string password',
    PHONETIPS: 'Please enter 11 mobile phone number',
    REPNEWPASSTIPS: 'Please enter your password again',
    VERCODETIPS: 'Image verification code',
    PHONECODETIPS: 'Phone verification code',
    IMGCODENULL: "Image verify code cannot be empty",
    IMGCODECORRECT: "Please enter the correct image code",
    CODENULL: "verify code must be filled",
    NEWPASSNULL: "New password cannot be empty",
    REPASSFAIL: "Inconsistent password entered twice",
    IMGSIZEOVER: "The picture size should be within 2M",
    CAN_NOT_BE_EMPTY: "Can not be empty"
}

export {
    cn,
    tw,
    en
}